<template lang="pug">
  BasePopup(@close="close(false)" v-if="isOpened")
    .material-orders-popup
      .orders
        .order(v-for="order in items" :key="order.id")
          .title {{ order.name }}, количество позиций {{ order.materials.length }}
          Btn(sm @click="selectOrder(order)") Выбрать заказ
          Btn(sm @click="deleteOrder(order)") X
      .form
        BaseInput.input(v-model="name")
        Btn(@click="createOrder") Создать заказ
</template>

<script>
import materialOrderApi from '@/api/materialOrder';

import BasePopup from '@/components/BasePopup.vue';
import BaseInput from '@/components/BaseInput.vue';

export default {
  name: 'MaterialOrdersPopup',
  components: { BaseInput, BasePopup },
  controller: null,
  props: {
    items: Array,
  },
  data() {
    return {
      isOpened: false,
      name: '',
    };
  },
  methods: {
    open() {
      this.isOpened = true;
      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      this.isOpened = false;
      this.$options.controller.resolve(null);
    },
    deleteOrder(order) {
      materialOrderApi.delete(order.id, true);
    },
    selectOrder(order) {
      this.$options.controller.resolve(order);
      this.isOpened = false;
    },
    createOrder() {
      const { name } = this;
      this.$options.controller.resolve({ name });
      this.isOpened = false;
      this.name = '';
    },
  },
};
</script>

<style scoped lang="scss">
.material-orders-popup {
  display: grid;
  gap: 20px;
}

.orders {
  display: grid;
  gap: 15px;
}

.order {
  display: flex;
  gap: 15px;
}

.title {
  margin-right: auto;
}

.form {
  display: flex;
  gap: 20px;
  align-items: center;
}

.input {
  flex-grow: 1;
}
</style>
